import { ChangeDetectionStrategy, Component, input, InputSignal, output, OutputEmitterRef } from '@angular/core';
import { SzRunRowComponent } from '@ui';
import { SessionRunRow } from './session-rep-list.types';

@Component({
  selector: 'lib-session-rep-list',
  templateUrl: './session-rep-list.component.html',
  styleUrls: ['./session-rep-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [SzRunRowComponent]
})
export class SessionRepListComponent {
  readonly rows: InputSignal<readonly SessionRunRow[]> = input.required<readonly SessionRunRow[]>();
  /** Tryb interaktywny (edycja/usuwanie runow). Wylaczany w widokach read-only, np. podsumowaniu sesji. */
  readonly interactive: InputSignal<boolean> = input<boolean>(true);

  readonly runEdit: OutputEmitterRef<string> = output<string>();
  readonly runDelete: OutputEmitterRef<string> = output<string>();
}
